export default __webpack_public_path__ + "static/media/blog.9ffc45e3.svg";